<script setup lang="ts"></script>
<template>
  <div class="section-analyze-tab"></div>
</template>
